import { Content } from 'antd/es/layout/layout';
import { Col, Descriptions, notification, Row, Steps } from 'antd';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import Title from 'antd/es/typography/Title';
import React, { useEffect, useState } from 'react';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import { getUnitForm } from '../../../api/module/unit_form';
import { catchException } from '../../../utils/helpers/helpers';
import SpinLoad from '../../../components/SpinLoad';
import { getFillOutForm } from '../../../api/module/fill_out_form';
import { querySections } from '../../../api/module/section_form';
import QuestionSection from './question_section';
import { queryQuestionsExpanded } from '../../../api/module/question';


export default function FillOutFormEdit({id}) {
  const [unidadFormularioId, setUnidadFormularioId] = React.useState(null);
  const [unitFormData, setUnitFormData] = useState({
    unidad_detalle1: undefined,
    unidad_detalle2: undefined,
    unidad_detalle3: undefined,
    unidad_detalle4: undefined,
    formulario_codigo: undefined,
    formulario_categoria: undefined,
    formulario_nombre: undefined,
    formulario_multiple: undefined,
  });
  const [fillOutForm, setFillOutForm] = React.useState({});
  const [loadingInfo, setLoadingInfo] = useState(false);
  const [loadingSections, setLoadingSections] = useState(false);
  const [sectionItems, setSectionItems] = useState([]);
  const [currentSection, setCurrentSection] = useState(0);
  const [nextSection, setNextSection] = useState(undefined);
  const [questions, setQuestions] = useState([]);
  const [loadingQuestions, setLoadingQuestions] = useState(false);

  const breadcrumbItems = [
    {
      text: 'Formularios - Diligenciamiento',
      to: `${INTERNAL_LINKS.FORMS_FILL_OUT}`,
    },
    {
      text: 'Formulario - Resumen',
      to: `${INTERNAL_LINKS.FORM_SUMMARY}/${unidadFormularioId}`,
    },
    {
      text: 'Formulario - Edición',
    },
  ];

  const fetchInitialData = async () => {
    try {
      setLoadingInfo(true);
      let fillOutFormData = await getFillOutForm(id);
      setFillOutForm(fillOutFormData.data);
      return await getUnitForm(fillOutFormData.data.unidad_formulario);
    } catch (error) {
      catchException(error);
    } finally {
      setLoadingInfo(false);
    }
  };

  const getSections = async () => {
    setLoadingSections(true);
    setLoadingQuestions(true);
    try {
      if (unidadFormularioId !== null) {
        let sections = await querySections({ 'filter[unidad_formulario]': unidadFormularioId });
        if (sections.data.results.length > 0) {
          setSectionItems(sections.data.results.map((item) => ({ key: item.id, title: item.nombre, next: item.siguiente_section })));
          await getQuestions(sections.data.results[0].id);
          if (sections.data.results[0].siguiente_section > 0) {
            setNextSection(sections.data.results[0].siguiente_section);
          }
        } else {
          notification.error({
            message: "Preguntas Formulario",
            description: "El formulario no posee secciones ni preguntas.",
            duration: 5,
          });
        }
      }
    } catch (e) {
      catchException(e);
    } finally {
      setLoadingSections(false);
      setLoadingQuestions(false);
    }
  };

  const reloadSection = (section) => {
    getQuestions(section).then((r) => {});
  };

  const onChangeSection = async (value) => {
    setCurrentSection(value);
    setNextSection(sectionItems[value].next);
    await getQuestions(sectionItems[value].key);
  };

  const getQuestions = async (sectionId) => {
    setLoadingQuestions(true);
    try {
      let q = await queryQuestionsExpanded({'seccion': sectionId, 'diligenciamiento': id});
      if (q.data.length > 0) {
        setQuestions(q.data);
      } else {
        setQuestions([]);
        notification.warning({
          message: "Preguntas de Sección",
          description: "La sección no tiene preguntas.",
          duration: 3,
        });
      }
    } catch (e) {
      catchException(e);
    } finally {
      setLoadingQuestions(false);
    }
  };

  useEffect(() => {
    fetchInitialData().then(r => {
      setUnitFormData(r.data);
      setUnidadFormularioId(r.data.id);
    });
  }, []);

  useEffect(() => {
    getSections().then(r => {});
  }, [unidadFormularioId]);

  const passToNextSection = async () => {
    if (nextSection !== undefined && nextSection !== null) {
      await onChangeSection(sectionItems.findIndex((item) => item.key === nextSection));
    }
  };

  return (
    <Content>
      <Row>
        <Col span={24}>
          <BreadcrumbContainer items={breadcrumbItems} />
        </Col>
        <Col span={24}>
          <Title className={'text-uppercase'} level={2}>
            Formulario - Edición
          </Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <SpinLoad loading={loadingInfo}>
            <Descriptions
              bordered
              column={4}
              title='Información Unidad'
              size='small'
              items={[
                {key: 1, label: 'Detalle1:', children: unitFormData?.unidad_detalle1, span: 2},
                {key: 2, label: 'Detalle2:', children: unitFormData?.unidad_detalle2, span: 2},
                {key: 3, label: 'Detalle3:', children: unitFormData?.unidad_detalle3, span: 2},
                {key: 4, label: 'Detalle4:', children: unitFormData?.unidad_detalle4, span: 2},
              ]}
            />
            <br />
            <Descriptions
              bordered
              column={4}
              title='Información Formulario'
              size='small'
              items={[
                {key: 1, label: 'Código:', children: unitFormData?.formulario_codigo, span: 2},
                {key: 2, label: 'Categoría:', children: unitFormData?.formulario_categoria, span: 2},
                {key: 3, label: 'Nombre:', children: unitFormData?.formulario_nombre, span: 'filled'},
                {key: 4, label: 'Estado:', children: fillOutForm?.estado, span: 2},
                {key: 5, label: 'Fecha de Creación:', children: fillOutForm?.created_at, span: 2},
              ]}
            />
          </SpinLoad>
        </Col>
      </Row>
      <Row style={{ marginTop: '40px' }} justify={'center'}>
        <Col span={24}>
          <SpinLoad loading={loadingSections}>
            <Steps current={currentSection} items={sectionItems} progressDot={true} size='small' onChange={onChangeSection} />
          </SpinLoad>
        </Col>
      </Row>
      <Row style={{ marginTop: '40px' }} justify={'center'}>
        <Col span={24}>
          <QuestionSection questions={questions} fillOutFormId={id} loadingQuestions={loadingQuestions} reload={reloadSection} nextSection={passToNextSection} />
        </Col>
      </Row>
    </Content>
  )
};
